(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSPerfilProyectoController', SSPerfilProyectoController);

    SSPerfilProyectoController.$inject = ['$scope', '$rootScope', '$state', '$stateParams', '$uibModalInstance', 'entity', 'ProgramaEducativo', 'Sexo', 'Principal', 'SSPerfil'];

    function SSPerfilProyectoController ($scope, $rootScope, $state, $stateParams, $uibModalInstance, entity, ProgramaEducativo, Sexo, Principal, SSPerfil) {
        var vm = this;

        vm.perfil = angular.copy(entity);
        vm.programasEducativos = ProgramaEducativo.distinct();
        vm.sexos = Sexo.query();

		vm.respDePrestador = {
				id : null,
				nombres : '',
				primerApellido : '',
				segundoApellido : '',
				titulo : '',
				email : '',
				telefono : '',
				telefono2 : '',
		};
			
		vm.actividad = {
				id : null,
				nombre : '',
				descripcion : ''
		}
		
		vm.indexRespDePrestador = null;  
		vm.isAdminCentral = false;
		vm. debeGuardar = false;
		
		vm.agregarActividad = agregarActividad;
		vm.removerActividad = removerActividad;
		vm.agregarRespDePrestador = agregarRespDePrestador;
		vm.removerRespDePrestador = removerRespDePrestador;
		vm.formEditarRespDePrestador = formEditarRespDePrestador;
		vm.editarRespDePrestador = editarRespDePrestador;
		vm.reactivarPerfil = reactivarPerfil;
		vm.desactivarPerfil = desactivarPerfil;
        vm.clear = clear;
        vm.save = save;
        
        onLoad();
	        
	    function onLoad(){
			Principal.hasAuthority('ADMINISTRADOR_DE_PROGRAMA_SS').then(function(result) {
                vm.isAdminCentral = result;
            });
		}
			
		function agregarActividad() {
			if (vm.perfil.actividads == null) {
				vm.perfil.actividads = [];
			}
			vm.perfil.actividads.push({
				nombre : vm.actividad.nombre,
				descripcion : vm.actividad.descripcion
			});
			vm.actividad = {
				id : null,
				nombre : null,
				descripcion : null
			}
			vm.showActivityForm = false;
		}

		function removerActividad(index) {
			vm.perfil.actividads.splice(index, 1);
		}

		function agregarRespDePrestador() {
			if (vm.perfil.respDePrestadors == null) {
				vm.perfil.respDePrestadors = [];
			}
			
			vm.perfil.respDePrestadors.push({
				nombres : vm.respDePrestador.nombres,
				primerApellido : vm.respDePrestador.primerApellido,
				segundoApellido : vm.respDePrestador.segundoApellido,
				titulo : vm.respDePrestador.titulo,
				email : vm.respDePrestador.email,
				telefono : vm.respDePrestador.telefono,
				telefono2 : vm.respDePrestador.telefono2,
			});
			
			vm.respDePrestador = {
				id : null,
				nombres : null,
				primerApellido : null,
				segundoApellido : null,
				titulo : null,
				email : null,
				telefono : null,
				telefono2 : null,
			}
			
			vm.showRespDePrestadorForm = false;
		}
		
		
		function formEditarRespDePrestador($index, prestador) {
			vm.indexRespDePrestador = $index;
			vm.showRespDePrestadorForm = true;
			vm.respDePrestador = prestador;
		}
		
		function editarRespDePrestador() {
			
			vm.perfil.respDePrestadors[vm.indexRespDePrestador].nombres = vm.respDePrestador.nombres;
			vm.perfil.respDePrestadors[vm.indexRespDePrestador].primerApellido = vm.respDePrestador.primerApellido;
			vm.perfil.respDePrestadors[vm.indexRespDePrestador].segundoApellido = vm.respDePrestador.segundoApellido;
			vm.perfil.respDePrestadors[vm.indexRespDePrestador].titulo = vm.respDePrestador.titulo;
			vm.perfil.respDePrestadors[vm.indexRespDePrestador].email = vm.respDePrestador.email;
			vm.perfil.respDePrestadors[vm.indexRespDePrestador].telefono = vm.respDePrestador.telefono;
			vm.perfil.respDePrestadors[vm.indexRespDePrestador].telefono2 = vm.respDePrestador.telefono2;
			
			vm.respDePrestador = {
				id : null,
				nombres : null,
				primerApellido : null,
				segundoApellido : null,
				titulo : null,
				email : null,
				telefono : null,
				telefono2 : null,
			}
			
			vm.showRespDePrestadorForm = false;
			vm.indexRespDePrestador = null;
		}

		function removerRespDePrestador(index) {
			vm.perfil.respDePrestadors.splice(index, 1);
		}
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
        function save () {
            $uibModalInstance.close(vm.perfil);
        }
        
        
        function desactivarPerfil(){
			SSPerfil.deactivate(
            	vm.perfil.id
            ).$promise.then(function(result) {
            	actualizarDatos(result);
             });
		}
		
		function reactivarPerfil(){
			SSPerfil.reactivate(
            	vm.perfil.id
            ).$promise.then(function(result) {
            	actualizarDatos(result);
             });
		}
		
		function actualizarDatos(result){
			vm.perfil.bajaReg = result.bajaReg;
            vm.perfil.usuarioUltAct = result.usuarioUltAct;
            vm.debeGuardar = true;
		}
        
    }
})();
